var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("section-title", {
        attrs: { content: "Fecha y Lugar", "has-line": "" }
      }),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12 col-md-4 mb-3" },
          [
            !_vm.isReadOnly
              ? _c("validation-provider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-date-picker", {
                              staticClass: "w-100",
                              attrs: {
                                "custom-error-msg": "Campo requerido.",
                                disabled: _vm.isReadOnly,
                                error: errors[0],
                                label: "Fecha:",
                                placeholder: "DD/MM/YYYY"
                              },
                              model: {
                                value: _vm.model.date,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "date", $$v)
                                },
                                expression: "model.date"
                              }
                            })
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    918466044
                  )
                })
              : _c("div", { staticClass: "d-flex flex-column" }, [
                  _c(
                    "label",
                    {
                      staticClass: "text-muted",
                      staticStyle: { "font-size": "14px" }
                    },
                    [_vm._v("Fecha:")]
                  ),
                  _c("span", [_vm._v(_vm._s(_vm._f("date")(_vm.model.date)))])
                ])
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-12 col-md-4 mb-3" },
          [
            _c("validation-provider", {
              attrs: { rules: "required" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      _c("custom-input", {
                        attrs: {
                          "custom-error-msg": "El campo es requerido.",
                          disabled: _vm.isReadOnly,
                          error: errors[0],
                          label: "Dirección (línea 1):"
                        },
                        model: {
                          value: _vm.model.addressLine1,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "addressLine1", $$v)
                          },
                          expression: "model.addressLine1"
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-12 col-md-4 mb-3" },
          [
            _c("custom-input", {
              attrs: {
                disabled: _vm.isReadOnly,
                label: "Dirección (línea 2):"
              },
              model: {
                value: _vm.model.addressLine2,
                callback: function($$v) {
                  _vm.$set(_vm.model, "addressLine2", $$v)
                },
                expression: "model.addressLine2"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-12 col-md-4 mb-3" },
          [
            !_vm.isReadOnly
              ? _c("validation-provider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-drop-down", {
                              attrs: {
                                clearable: "",
                                "custom-error-msg": "El campo es requerido.",
                                disabled: _vm.isReadOnly,
                                error: errors[0],
                                fieldkey: "id",
                                fieldname: "name",
                                label: "País:",
                                options: _vm.countries
                              },
                              on: { input: _vm.onCountryChange },
                              model: {
                                value: _vm.model.country,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "country", $$v)
                                },
                                expression: "model.country"
                              }
                            })
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    2334525547
                  )
                })
              : _c("div", { staticClass: "d-flex flex-column" }, [
                  _c(
                    "label",
                    {
                      staticClass: "text-muted",
                      staticStyle: { "font-size": "14px" }
                    },
                    [_vm._v("País:")]
                  ),
                  _c("span", [
                    _vm._v(_vm._s(_vm._f("empty")(_vm.model.country?.name)))
                  ])
                ])
          ],
          1
        ),
        _vm.isUSA
          ? _c(
              "div",
              { staticClass: "col-12 col-md-4 mb-3" },
              [
                _c("validation-provider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-drop-down", {
                              attrs: {
                                clearable: "",
                                "custom-error-msg": "El campo es requerido.",
                                disabled: _vm.isReadOnly,
                                error: errors[0],
                                fieldkey: "id",
                                fieldname: "name",
                                label: "Estado:",
                                options: _vm.states
                              },
                              on: { input: _vm.onStateChange },
                              model: {
                                value: _vm.model.state,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "state", $$v)
                                },
                                expression: "model.state"
                              }
                            })
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    4009352166
                  )
                })
              ],
              1
            )
          : _vm._e(),
        _vm.isPuertoRico
          ? _c(
              "div",
              { staticClass: "col-12 col-md-4 mb-3" },
              [
                _c("validation-provider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-drop-down", {
                              attrs: {
                                clearable: "",
                                "custom-error-msg": "El campo es requerido.",
                                disabled: _vm.isReadOnly,
                                error: errors[0],
                                fieldkey: "id",
                                fieldname: "name",
                                label: "Municipio:",
                                options: _vm.municipalities
                              },
                              model: {
                                value: _vm.model.municipality,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "municipality", $$v)
                                },
                                expression: "model.municipality"
                              }
                            })
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    3623263669
                  )
                })
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "col-12 col-md-4 mb-3" },
          [
            _c("validation-provider", {
              attrs: { rules: "required" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      _c("custom-input", {
                        attrs: {
                          "custom-error-msg": "El campo es requerido.",
                          disabled: _vm.isReadOnly,
                          error: errors[0],
                          label: "Código postal:",
                          "mask-type": "ZipcodeExt"
                        },
                        model: {
                          value: _vm.model.zipCode,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "zipCode", $$v)
                          },
                          expression: "model.zipCode"
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-12 mb-3" },
          [
            !_vm.isReadOnly
              ? _c("validation-provider", {
                  attrs: { rules: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-text-area", {
                              attrs: {
                                "count-classes": [
                                  "d-block",
                                  "small-counter",
                                  "text-right"
                                ],
                                "custom-error-msg":
                                  "El comentario es requerido.",
                                disabled: _vm.isReadOnly,
                                error: errors[0],
                                label: "Comentario Adicional",
                                maxlength: 5000,
                                "show-char-count": !_vm.isReadOnly
                              },
                              model: {
                                value: _vm.model.additionalComments,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "additionalComments", $$v)
                                },
                                expression: "model.additionalComments"
                              }
                            })
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    4042289145
                  )
                })
              : _c("div", { staticClass: "d-flex flex-column" }, [
                  _c("label", { staticStyle: { "font-size": "14px" } }, [
                    _vm._v("Comentario Adicional:")
                  ]),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm._f("empty")(_vm.model.additionalComments))
                    )
                  ])
                ])
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }